import React, { FC, Fragment, Suspense } from 'react';
import { getInvoicesForDentistTemplate } from 'apollo/templates/invoices';
import PageTitle from 'components/shared/page-title/page-title.component';
import { useTranslation } from 'react-i18next';
import Invoices from './invoices/invoices.component';

const InvoicingForDentist: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    return (
        <Fragment>
            <PageTitle headingStyle="h1" title={translate('INVOICES')} />
            <Suspense fallback={null}>
                <Invoices queryName="invoicesForDentist" queryTemplate={getInvoicesForDentistTemplate} />
            </Suspense>
        </Fragment>
    );
};

export default InvoicingForDentist;
